import { useLayoutEffect, useRef } from "react"

export const useElementFocus = () => {
  const ref = useRef(null)

  useLayoutEffect(() => {
    if (ref.current) {
      ref.current.focus?.();
    }
  }, [])

  return ref
}